module.exports = __webpack_public_path__ + "static/img/about-banner.f653bd15.png";